import React, { useState, useEffect, useRef } from 'react'
import './reports-change-access.scss'
import {
  GridComponent,
  Inject,
  Toolbar,
  ToolbarItems,
  Edit,
  EditSettingsModel,
  Page,
  Sort,
  PdfExport,
  PdfExportProperties,
  ExcelExport,
  Grid,
  Resize,
  FilterSettingsModel,
  Filter,
  Group,
  GroupSettingsModel,
  AggregateColumnDirective,
  ColumnDirective,
  ColumnsDirective,
  AggregateColumnsDirective,
  AggregateDirective,
  AggregatesDirective,
  Aggregate,
  Freeze,
  ColumnChooser,
  Reorder,
  DialogEditEventArgs,
  CommandColumn,
  CommandModel,
} from '@syncfusion/ej2-react-grids';
import { AutoCompleteComponent } from '@syncfusion/ej2-react-dropdowns';
import { CheckBoxComponent } from '@syncfusion/ej2-react-buttons';
import { DialogUtility } from '@syncfusion/ej2-popups';
import SecurityService from '../security.service';
import moment from 'moment';
import usersService from '../../../services/users.service';
import DropdownService from '../../software-dynamic-version-2/api.service-v-2';

let Ids = []
let userSecurityItemGrid: Grid;
export default function ChangeAccessReports(props) {
  const [userSecurityItems, setUserSecurityItems] = useState([]);
  const [ids, setIds] = useState([]);
  const [userIDs, setUserIDs] = useState(0);
  const [userID, setUserID] = useState(0);
  let headerCheckbox = useRef();
  let userRef = useRef();

 useEffect(() => {
    getUserIDs();
  }, []);

  const getUserSecurityItems = async (id) => {
    SecurityService.getReportsUserAccess(id)
      .then((response) => {
        setUserSecurityItems(response.data.recordset);
      })
      .catch((e) => {
        userSecurityItemGrid?.refresh();
        console.log(e);
      });
  };

  const getUserIDs = async () => {
    DropdownService.getAllForList('UserInfo')
      .then((response) => {
        setUserIDs(response?.data?.recordset);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const userIDChange = (e) => {
    if (e?.itemData?.id) {
      setUserID(e.itemData.id);
      if(e?.itemData?.id){
      getUserSecurityItems(e?.itemData?.id)
      }
    }
  }

  const toolbarClick = (args: ClickEventArgs) => {
    // console.log(args);
    if (
      userSecurityItemGrid &&
      args.item.properties.id === 'UserSecurityItemGrid_PDFExport'
    ) {

      const exportProperties: PdfExportProperties = {
        pageOrientation: 'Landscape',
        pageSize: 'A3',
        fileName: `${moment().format('YYYYMMDD')}_yarn_purchase_contract.pdf`
      };

      // console.log('clicked on pdf export');
      userSecurityItemGrid.pdfExport(exportProperties);

    }

    if (
      userSecurityItemGrid &&
      args.item.properties.id === 'UserSecurityItemGrid_excelexport'
    ) {
      const exportProperties: PdfExportProperties = {
        fileName: `${moment().format('YYYYMMDD')}_yarn_purchase_contract.xlsx`
      };
      userSecurityItemGrid.excelExport(exportProperties);
    }
    // if (
    //   userSecurityItemGrid &&
    //   args.item.properties.id === 'UserSecurityItemGrid_columnchooser'
    // ) {
    // }
    if (args?.item?.properties?.id === 'Cancel') {
      // console.log(userSecurityItems);
      // to reload the grid
      setUserSecurityItems([]);
      getUserSecurityItems(userID);

      // userSecurityItemGrid?.refresh();
      // userSecurityItemGrid?.refreshDataSource();
      userSecurityItemGrid?.toolbarModule?.enableItems(['Update', 'Cancel'], false);
    }
    if (args?.item?.properties?.id === 'Update') {
      // console.log(userSecurityItemGrid?.getCurrentViewRecords());
      userSecurityItemGrid?.editModule?.batchSave();
      // console.log(userSecurityItemGrid?.getCurrentViewRecords());
      // userSecurityItemGrid?.toolbarModule?.enableItems(['Update', 'Cancel'], false);
    }
  };

  const toolbarOptions: ToolbarItems[] = [
    {
      text: "Cancel", tooltipText: "Cancel", id: "Cancel", disabled: true
    },
    {
      text: "Update", tooltipText: "Update", id: "Update", disabled: true
    }
  ];

  const editSettings: EditSettingsModel = {
    allowEditing: true,
    mode: 'Batch',
    showConfirmDialog: false
  };

  const filterOptions: FilterSettingsModel = {
    type: 'Excel',
    
  };

  const groupOptions: GroupSettingsModel = {
    showDroopArea: true,
  };

  const sortingOptions: SortSettingsModel = {
    columns: [{ field: 'ReportID', direction: 'Descending' }]
  }

  const formatOptions = { type: 'date', format: 'dd/MM/yy' }

  const actionComplete = (args: DialogEditEventArgs) => {
    if (args?.requestType === 'columnstate') {
      // console.log('adjusting column');
      userSecurityItemGrid?.autoFitColumns();
    }
    if (args?.requestType === 'paging' || args?.requestType === 'refresh') {
      const currentData = userSecurityItemGrid.getCurrentViewRecords();
      if (currentData.every((el) => el.CanSELECT === true)) {
        headerCheckbox.current.checked = true;
       }
    }
    // if (args?.requestType === 'paging') {
    //   alert('Confirm changes');
    // }
    // console.log('check', args);
    if (args.form && args.form.ej2_instances) {
      // if (args.requestType === 'beginEdit' || args.requestType === 'add') {
      //   /** Add Validation Rules */
      //   // args.form.ej2_instances[0].addRules('OrderID', { max: 500 });
      //   args.form.ej2_instances[0].addRules('OrderDate', {
      //     required: true,
      //   });
      //   args.form.ej2_instances[0].addRules('ContractStartDate', {
      //     required: true,
      //   });
      //   args.form.ej2_instances[0].addRules('ContractEndDate', {
      //     required: true,
      //   });
      //   args.form.ej2_instances[0].addRules('CompanyName', { required: true });
      //   args.form.ej2_instances[0].addRules('FullYarnCount', {
      //     required: true,
      //   });
      //   args.form.ej2_instances[0].addRules('YarnBrand', { required: true });
      //   args.form.ej2_instances[0].addRules('ImportLCNo', { required: true });
      //   args.form.ej2_instances[0].addRules('OrderBags', { required: true });
      //   args.form.ej2_instances[0].addRules('WeightPerBag', { required: true });
      //   args.form.ej2_instances[0].addRules('ProcurementType', {
      //     required: true,
      //   });
      //   args.form.ej2_instances[0].addRules('Currency', { required: true });
      //   args.form.ej2_instances[0].addRules('ForeignCurrencyRate', {
      //     required: true,
      //   });
      //   args.form.ej2_instances[0].addRules('ForeignCurrencyAmount', {
      //     required: true,
      //   });
      //   args.form.ej2_instances[0].addRules('ContractExchangeRate', {
      //     required: true,
      //   });
      //   args.form.ej2_instances[0].addRules('Rate', { required: true });
      //   args.form.ej2_instances[0].addRules('RatePer', { required: true });

      //   args.form.ej2_instances[0].addRules('TaxType', { required: true });
      //   args.form.ej2_instances[0].addRules('TaxPercent', { required: true });
      //   args.form.ej2_instances[0].addRules('PaymentTerms', {
      //     required: true,
      //   });

      //   args.form.ej2_instances[0].addRules('DeliveryStatus', {
      //     required: true,
      //   });

      //   args.form.ej2_instances[0].addRules('PaymentDays', {
      //     required: true,
      //   });
      // }
    }
    if (args.requestType === 'batchsave') {
      const data = {
        rows: 1
      };
      // console.log('current data:', userSecurityItemGrid?.dataSource);
      // console.log('data: ', args.rows.map((elem) => elem.data));


  // old api of change access start
      // SecurityService.changeAccess(userSecurityItemGrid?.dataSource)
      //   .then((response) => {
      //     // setUserSecurityItems([]);
      //     // getUserSecurityItems(userID);
      //     userSecurityItemGrid?.toolbarModule?.enableItems(['Update', 'Cancel'], false);
      //   });
      // old api of change access end
      
      console.log('list ids'   , ids , Ids)
      
      // menu
      let totalID = [...ids , ...Ids]
      let uniqueArrayMenu = [...new Set(totalID)];
      console.log(uniqueArrayMenu)
      let arrayofobjectsMenu = userSecurityItemGrid?.dataSource;
      let filterObjMenu = arrayofobjectsMenu.filter((res)=>{ return  uniqueArrayMenu.includes(res.ReportID)})
      
      console.log(filterObjMenu)
      
      if(filterObjMenu != []){
      console.log(filterObjMenu)
      SecurityService.changeAccessReports(filterObjMenu ,SecurityService.getLoggedInUserId())
        .then((response) => {
          // setUserSecurityItems([]);
          // getUserSecurityItems(userID);
          userSecurityItemGrid?.toolbarModule?.enableItems(['Update', 'Cancel'], false);
        });
      }
      
      userSecurityItemGrid?.toolbarModule?.enableItems(['Update', 'Cancel'], false);

    }
  };



  const ddlFields: object = { value: 'value' };

  
  const checkboxChange = (args) => {
    let UserReportIDs =  userSecurityItemGrid?.getCurrentViewRecords().map((val)=>{
      return val.ReportID;
    })
    console.log(userSecurityItemGrid?.getCurrentViewRecords())
    // UserReportIDs
    setIds([...ids , ...UserReportIDs])
    let currentData = userSecurityItemGrid?.getCurrentViewRecords();

    currentData && currentData.map((el) => {
      el.CanSELECT = args.checked
    });
    // console.log(currentData);
    userSecurityItemGrid.refreshColumns();
    userSecurityItemGrid?.toolbarModule?.enableItems(['Update', 'Cancel'], true);
    // userSecurityItemGrid.editModule.batchSave();
  }
  
  const headerTemplateList = () => (
    <div>
      <CheckBoxComponent ref={headerCheckbox} id='userCanAcessCheckBox' change={checkboxChange} />
      &nbsp;
      <span> Reports</span>
    </div>
  )
  
  return (
    <div className='content-wrapper'>
      <div>
        <h3 style={{ textAlign: 'left' }}> Change Access - Edit</h3>
        <div className='user-selection-container'>
          <AutoCompleteComponent
            id="User" dataSource={userIDs}
            ref={userRef}
            placeholder="Select User" fields={ddlFields}
            floatLabelType='Auto' highlight={true}
            select={userIDChange}
            change={userIDChange}
            focus={()=>{
              userRef.current.showPopup()
            }}
          />
        </div>
        <br />
        <GridComponent
          id="UserSecurityItemGrid"
          ref={(grid) => userSecurityItemGrid = grid}
          dataSource={userSecurityItems}
          editSettings={editSettings}
          toolbar={toolbarOptions}
          pageSettings={{ pageCount: 4, pageSizes: true }}
          filterSettings={filterOptions}
          groupSettings={groupOptions}
          actionComplete={actionComplete}
          allowPaging={true}
          allowSorting={true}
          toolbarClick={toolbarClick}
          allowFiltering={true}
          allowGrouping={true}
          showColumnChooser={true}
          allowReordering={true}
          allowTextWrap='wrap'
          allowResizing={true}
          sortSettings={sortingOptions}
          created={() => {
            userSecurityItemGrid?.toolbarModule?.enableItems(['Update', 'Cancel'], false)
          }}
        // actionBegin={actionBegin}
        >
          <ColumnsDirective>
            <ColumnDirective
              field="ModuleID"
              headerText="ID"
              width="40"
              textAlign="Right"
              allowEditing={false}
              isPrimaryKey={true}
            />
            <ColumnDirective
              field="ModuleName"
              headerText="Module Name"
              width="90"
              // valueAccessor={spaceOutItemName}
              allowEditing={false}
            />
            <ColumnDirective
              // field="InputName"
              field="ReportName"
              headerText="Report Name"
              width="90"
              // valueAccessor={spaceOutItemName}
              allowEditing={false}
            />
            
            
            <ColumnDirective
              field="CanSELECT"
              headerText="Add"
              width="70"
              // allowEditing={true}
              // displayAsCheckBox={true}
              // editType="booleanedit"
              template={(data) => (
                <CheckBoxComponent checked={data.CanSELECT} change={(args) => {
                  //userSecurityItemGrid.editModule.updateCell(args.event.target.closest('tr').rowIndex, 'CanAccessAdd', args.checked);
                  // userSecurityItemGrid.editModule.saveCell();
                  Ids =  [...Ids , data.ReportID]
                  const currentData = userSecurityItemGrid?.getCurrentViewRecords();
                  if (currentData) {
                    currentData[args.event.target.closest('tr').rowIndex].CanSELECT = args.checked;
                    userSecurityItemGrid?.toolbarModule?.enableItems(['Update', 'Cancel'], true);
                    // userSecurityItemGrid?.editModule?.batchSave();
                  }
                }} />
              )}
              allowFiltering={false}
              allowSorting={false}
              headerTemplate={headerTemplateList}
            />
            
          </ColumnsDirective>
          <Inject services={[
            Resize,
            Edit,
            Toolbar,
            Page,
            Sort,
            PdfExport,
            ExcelExport,
            Filter,
            Group,
            Aggregate,
            Freeze,
            ColumnChooser,
            Reorder,
            CommandColumn,
          ]} />
        </GridComponent>
      </div>
    </div >
  )
}
